import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    filterInputs: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '16px',
    },
    label: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      fontSize: '12px',
      display: 'inline-flex',
      alignItems: 'center',
      color: '#727970',
    },
    select: {
      height: '20px',
      fontSize: '12px',
    },
  }),
)
